import React, { useEffect, useState } from "react";
import { Container, Row } from "shards-react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PageTitle from "../../components/common/PageTitle";
import {
  ButtonGroup,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Button,
  Menu,
  makeStyles
} from "@material-ui/core";
import TextFieldComponentFilter from "../../utils/TextFieldComponentFilter";
import { Add, Remove } from "@material-ui/icons";
import AllMeetingNotes from "./AllMeetingNotes";
import SearchMeetingNotes from "./SearchMeetingNotes";
import ListIcon from "@material-ui/icons/List";
import GridOnIcon from "@material-ui/icons/GridOn";
import { useHistory } from "react-router";
import AllMeetingNotesCustomerBased from "./AllMeetingNotesCustomerBased";

const useStyles = makeStyles({
  text: {
    fontFamily: "Noto Sans Malayalam, sans-serif",
    fontSize: "14px",
    color: "#3D5279"
  },
  icon: {
    color: "#3D5279"
  },
  filterButton: {
    backgroundColor: "#fff",
    borderRadius: "5px",
    color: "#3D5279",
    fontFamily: "Noto Sans Malayalam, sans-serif",
    "&:hover": {
      backgroundColor: "#3D5279",
      color: "#fff"
    }
  }
});

const articlePerPageSelect = [5, 10, 20, 50, 100];

const sorts = [
  { text: "Sort by descending", value: "created_at:desc" },
  { text: "Sort by ascending", value: "created_at:asc" }
];
export default function BlogPosts() {
  const history = useHistory();
  const [selectedType, setSelectedType] = useState("All");
  const [viewType, setViewType] = useState("list");

  const [selectedSort, setSelectedSort] = useState("created_at:desc");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [articlePerPage, setArticlePerPage] = useState(10);
  const [selectedPageNumber, setSelectedPageNumber] = useState(0);

  const [selectedFilter, setSelectedFilter] = useState("all");

  const [pageDataCount, setPageDataCount] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_API_URI}/meetingNotes/count`).then(res => {
  //     console.log("res.datares.data",res.data);
  //     setArticleCount(res.data)
  //   }
  //   ).catch(err => {

  //   })
  // }, [])

  const classes = useStyles();
  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Meeting Notes" className="text-sm-left" />
      </Row>
      <Grid container spacing={2}>
        <Grid item container>
          <SearchMeetingNotes setSelectedCustomerId={setSelectedCustomerId} />
        </Grid>

        <Grid item container justifyContent="space-between">
          <Grid item container lg={6}>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              disableUnderline
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "20px"
              }}
              value={selectedSort}
              onChange={e => setSelectedSort(e.target.value)}
            >
              {sorts.map(sort => (
                <MenuItem key={sort.value} value={sort.value}>
                  {sort.text}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid
            container
            lg={6}
            direction="row-reverse"
            spacing={3}
            alignItems="flex-start"
          >
            <Grid item>
              <IconButton
                style={{
                  backgroundColor: viewType == "list" ? "gray" : "#fff"
                }}
                onClick={() => setViewType("list")}
              >
                <ListIcon
                  className={classes.icon}
                  style={{ color: viewType == "list" ? "#fff" : "#3D5279" }}
                />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton
                style={{
                  backgroundColor: viewType == "card" ? "gray" : "#fff"
                }}
                onClick={() => setViewType("card")}
              >
                <GridOnIcon
                  className={classes.icon}
                  style={{ color: viewType == "card" ? "#fff" : "#3D5279" }}
                />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>

        <Grid item container>
          {selectedCustomerId ? (
            <AllMeetingNotesCustomerBased
              viewType={viewType}
              setPageDataCount={setPageDataCount}
              type={selectedType === "All" ? "" : selectedType}
              articlePerPage={articlePerPage}
              selectedCustomerId={selectedCustomerId}
              page={selectedPageNumber}
              selectedSort={selectedSort}
              publicationState={
                selectedFilter === "published" ? "LIVE" : "PREVIEW"
              }
              published_at_null={
                selectedFilter === "published"
                  ? false
                  : selectedFilter === "all"
                  ? null
                  : true
              }
            />
          ) : (
            <AllMeetingNotes
              viewType={viewType}
              setPageDataCount={setPageDataCount}
              type={selectedType === "All" ? "" : selectedType}
              articlePerPage={articlePerPage}
              page={selectedPageNumber}
              selectedSort={selectedSort}
              publicationState={
                selectedFilter === "published" ? "LIVE" : "PREVIEW"
              }
              published_at_null={
                selectedFilter === "published"
                  ? false
                  : selectedFilter === "all"
                  ? null
                  : true
              }
            />
          )}
        </Grid>
        <Grid item container justifyContent="space-between">
          <Grid item>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              disableUnderline
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "20px"
              }}
              value={articlePerPage}
              onChange={e => {
                setArticlePerPage(e.target.value);
                setSelectedPageNumber(0);
              }}
            >
              {articlePerPageSelect.map(select => (
                <MenuItem key={select} value={select}>
                  {select} entries per page
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item>
            <ButtonGroup variant="outlined">
              <Button
                style={{
                  backgroundColor: "#fff"
                }}
                onClick={() => setSelectedPageNumber(selectedPageNumber - 1)}
                disabled={selectedPageNumber === 0}
              >
                <ArrowBackIosIcon className={classes.icon} />
              </Button>
              <Button
                style={{
                  backgroundColor: "#fff",
                  color: "#000"
                }}
              >
                {selectedPageNumber}
              </Button>
              <Button
                style={{
                  backgroundColor: "#fff"
                }}
                onClick={() => setSelectedPageNumber(selectedPageNumber + 1)}
                disabled={pageDataCount / articlePerPage < 1}
              >
                <ArrowForwardIosIcon className={classes.icon} />
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
